<template lang="pug">
.compensacao-table
    grid-table-component(:headers='headersolicitacaoAutoriz', :data='solicitacaoAutorizacaoManejo', :is-paginated='false')
        template(v-slot:aprovado='{ item }')
            validacao-component(
                :id='item.tipo + "radioselect"'
                :tipo='item.tipo',
                :item='item',
                :tipos-documentos='tiposDocumentos',
                @validacao='validar(item, $event)'
            )

        template(v-slot:acao='{ item }')
            dropdown-component(
                :list='item.acao'
                @input="onAction($event, item)"
                :is-select='false'
                position='left'
            )
    modal-component(
        v-if='analiseModalFlag',
        :title='selectedEtapa.tipo + " documentos"',
        @close='analiseModalFlag = false'
    )
        AnaliseModalDocumentos(:etapa='selectedEtapa')
</template>

<script>
import AnaliseModalDocumentos from '@/views/analise/components/AnaliseModalDocumentos.vue';
import ValidacaoComponent from '@/views/analise/components/ValidacaoComponent.vue';

export default {

    name: 'IaraSolicitacaoAutorizacaoTable',

    components: {
        AnaliseModalDocumentos,
        ValidacaoComponent
    },

    props: {
        solicitacaoAutorizacaoManejo: {
            type: Array,
            required: true,
        },

        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            headersolicitacaoAutoriz: [
                { text: 'Tipo', field: 'tipo' },
                { text: 'Produto', field: 'nomeProduto' },
                { text: 'Espécie', field: 'nomeEspecie' },
                { text: 'Quantidade', field: 'quantidadeUnidadeMedida' },
                { text: 'Cronograma (anos)', field: 'cronogramaAnos' },
                { text: 'Avaliação', field: 'aprovado' },
            ],

            aprovadoOptions: [
                { id: 1, label: 'Aprovado', isChecked: false },
                { id: 2, label: 'Reprovado', isChecked: false },
            ],

            selectedEtapa: null,
            analiseModalFlag: false,
        };
    },

    methods: {

        modalDocumentos(item) {
            this.selectedEtapa = item;
            this.analiseModalFlag = true;
        },

        validar(item, validacao) {
            this.$emit('itemValidados', { key: 'SOLICITACAO_AUTORIAZACAO', data: this.solicitacaoAutorizacaoManejo, validacao });
        },

        onAction(event, item) {
            if (event.id === 'DOC') {
                this.modalDocumentos(item);
            }
        }
    },
};
</script>

<style >
.radio-position {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
}
</style>
